export const maxResults = 25;
export const debounceTime = 500;
export const minQueryLength = 3;
export const defaultValue = '';
